require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./evnement-0-9-5.json") })
        }
      }, "path---evnement-0-9-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---evnement-0-9-5!./.cache/json/evnement-0-9-5.json
// module id = 426
// module chunks = 231608221292675